import React, { memo, useEffect, useState } from "react";
import AddProduct from "../addProduct/AddProduct";
import { findAllProduct } from "../../../../api/inventoryService";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import InventoryIcon from "@mui/icons-material/Inventory";
import SearchIcon from "@mui/icons-material/Search";
import WarningIcon from "@mui/icons-material/Warning";

function AllProduct() {
  const [open, setopen] = useState(false);
  const [id, setid] = useState("");
  const [priceOnly, setpriceOnly] = useState(true);
  const [data, setdata] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    findAllProduct()
      .then((data) => setdata(data as never[]))
      .catch((error) => console.error(error?.response));
  }, [open]);

  const closeModal = () => {
    setopen(false);
    setid("");
  };

  const openModal = () => {
    setopen(true);
    setpriceOnly(false);
  };

  const updatePrice = (id: any) => {
    setid(id);
    setopen(true);
    setpriceOnly(true);
  };

  const filteredData = data.filter((item: any) =>
    item?.productName?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
      {/* Header Card */}
      <div className="bg-white dark:bg-slate-800 rounded-[8px] shadow-lg shadow-slate-200/50 dark:shadow-slate-900/50 border border-slate-100 dark:border-slate-700 p-3 mb-3">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2.5">
          <div className="relative flex-1 max-w-md">
            <SearchIcon
              className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 dark:text-slate-500"
              sx={{ fontSize: 16 }}
            />
            <input
              type="search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search products..."
              className="w-full pl-10 pr-3 py-2 bg-slate-50 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded-lg focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all text-xs text-slate-800 dark:text-slate-200 placeholder:text-slate-400 dark:placeholder:text-slate-500"
            />
          </div>
          <div className="flex items-center gap-2.5">
            <div className="flex items-center gap-1.5 px-3 py-1.5 bg-blue-50 dark:bg-blue-900/40 rounded-lg">
              <InventoryIcon className="text-blue-500 dark:text-blue-300" sx={{ fontSize: 16 }} />
              <span className="font-bold text-xs text-blue-600 dark:text-blue-300">{data.length}</span>
              <span className="text-slate-500 dark:text-slate-400 text-[10px]">Products</span>
            </div>
            <button
              onClick={() => openModal()}
              className="flex items-center gap-1.5 px-4 py-2.5 bg-gradient-to-r from-primary to-primaryLight text-white rounded-lg hover:shadow-lg hover:shadow-primary/20 transition-all font-medium text-xs"
            >
              <AddIcon sx={{ fontSize: 16 }} />
              Add Product
            </button>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white dark:bg-slate-800 rounded-[8px] shadow-lg shadow-slate-200/50 dark:shadow-slate-900/50 border border-slate-100 dark:border-slate-700 overflow-hidden">
        {/* Mobile Cards */}
        <div className="md:hidden p-3 space-y-2">
          {filteredData.length === 0 ? (
            <div className="text-center py-8 text-slate-400 dark:text-slate-500">
              <InventoryIcon sx={{ fontSize: 36 }} className="mb-2" />
              <p className="text-xs">No products found</p>
            </div>
          ) : (
            filteredData.map((item: any, i: number) => (
              <div key={i} className="bg-slate-50 dark:bg-slate-700/50 rounded-lg p-3 border border-slate-100 dark:border-slate-600">
                <div className="flex items-start justify-between mb-2">
                  <div>
                    <p className="font-semibold text-xs text-slate-800 dark:text-slate-100">{item?.productName}</p>
                    <div className="flex flex-wrap gap-1.5 mt-1">
                      <span className="px-1.5 py-0.5 bg-indigo-100 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-300 rounded-md text-[10px]">
                        {item?.brandId?.brandName}
                      </span>
                      <span className="px-1.5 py-0.5 bg-emerald-100 dark:bg-emerald-900/40 text-emerald-600 dark:text-emerald-300 rounded-md text-[10px]">
                        {item?.subCategoryId?.categoryId?.categoryName ?? "—"}
                      </span>
                      <span className="px-1.5 py-0.5 bg-teal-100 dark:bg-teal-900/40 text-teal-600 dark:text-teal-300 rounded-md text-[10px]">
                        {item?.subCategoryId?.subCategoryName ?? "—"}
                      </span>
                    </div>
                  </div>
                  {item?.availableQuantity <= item?.alertQuantity && (
                    <WarningIcon className="text-amber-500" sx={{ fontSize: 16 }} />
                  )}
                </div>
                <div className="grid grid-cols-3 gap-1.5 mb-2">
                  <div className="bg-white dark:bg-slate-700 rounded-md p-1.5 text-center">
                    <p className="text-[10px] text-slate-500 dark:text-slate-400">Price</p>
                    <p className="font-semibold text-xs text-emerald-600 dark:text-emerald-300">{item?.price}</p>
                  </div>
                  <div className="bg-white dark:bg-slate-700 rounded-md p-1.5 text-center">
                    <p className="text-[10px] text-slate-500 dark:text-slate-400">Stock</p>
                    <p className={`font-semibold text-xs ${item?.availableQuantity <= item?.alertQuantity ? "text-red-500 dark:text-red-400" : "text-slate-700 dark:text-slate-200"}`}>
                      {item?.availableQuantity}
                    </p>
                  </div>
                  <div className="bg-white dark:bg-slate-700 rounded-md p-1.5 text-center">
                    <p className="text-[10px] text-slate-500 dark:text-slate-400">Alert</p>
                    <p className="font-semibold text-xs text-amber-600 dark:text-amber-300">{item?.alertQuantity}</p>
                  </div>
                </div>
                <button
                  onClick={() => updatePrice(item._id)}
                  className="w-full flex items-center justify-center gap-1 px-3 py-2 bg-gradient-to-r from-primary to-primaryLight text-white rounded-lg hover:shadow-lg hover:shadow-primary/20 transition-all text-xs font-medium"
                >
                  <EditIcon sx={{ fontSize: 14 }} />
                  Update Price
                </button>
              </div>
            ))
          )}
        </div>

        {/* Desktop Table */}
        <div className="hidden md:block overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-slate-200 dark:border-slate-600">
                <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-300 uppercase tracking-wider">No</th>
                <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-300 uppercase tracking-wider">Name</th>
                <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-300 uppercase tracking-wider">Brand</th>
                <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-300 uppercase tracking-wider">Category</th>
                <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-300 uppercase tracking-wider">Sub Category</th>
                <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-300 uppercase tracking-wider">Alert Qty</th>
                <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-300 uppercase tracking-wider">Price</th>
                <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-300 uppercase tracking-wider">Stock</th>
                <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-300 uppercase tracking-wider">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100 dark:divide-slate-600">
              {filteredData.length === 0 ? (
                <tr>
                  <td colSpan={9} className="px-3 py-8 text-center text-slate-400 dark:text-slate-500">
                    <InventoryIcon sx={{ fontSize: 36 }} className="mb-2" />
                    <p className="text-xs">No products found</p>
                  </td>
                </tr>
              ) : (
                filteredData.map((item: any, i: number) => (
                  <tr key={i} className={`hover:bg-slate-50/50 dark:hover:bg-slate-700/50 transition-colors ${item?.availableQuantity <= item?.alertQuantity ? "bg-red-50/50 dark:bg-red-900/20" : ""}`}>
                    <td className="px-3 py-2">
                      <span className="px-2 py-0.5 text-[10px] font-semibold rounded-md bg-slate-100 dark:bg-slate-600 text-slate-600 dark:text-slate-300">
                        {i + 1}
                      </span>
                    </td>
                    <td className="px-3 py-2">
                      <span className="font-medium text-xs text-slate-800 dark:text-slate-100">{item?.productName}</span>
                    </td>
                    <td className="px-3 py-2">
                      <span className="px-2 py-0.5 bg-indigo-50 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-300 rounded-md text-[10px] font-medium">
                        {item?.brandId?.brandName}
                      </span>
                    </td>
                    <td className="px-3 py-2">
                      <span className="px-2 py-0.5 bg-emerald-50 dark:bg-emerald-900/40 text-emerald-600 dark:text-emerald-300 rounded-md text-[10px] font-medium">
                        {item?.subCategoryId?.categoryId?.categoryName ?? "—"}
                      </span>
                    </td>
                    <td className="px-3 py-2">
                      <span className="px-2 py-0.5 bg-teal-50 dark:bg-teal-900/40 text-teal-600 dark:text-teal-300 rounded-md text-[10px] font-medium">
                        {item?.subCategoryId?.subCategoryName ?? "—"}
                      </span>
                    </td>
                    <td className="px-3 py-2 text-xs text-amber-600 dark:text-amber-300 font-medium">{item?.alertQuantity}</td>
                    <td className="px-3 py-2">
                      <span className="font-semibold text-xs text-emerald-600 dark:text-emerald-300">{item?.price}</span>
                    </td>
                    <td className="px-3 py-2">
                      <span className={`font-semibold text-xs ${item?.availableQuantity <= item?.alertQuantity ? "text-red-500 dark:text-red-400" : "text-slate-700 dark:text-slate-200"}`}>
                        {item?.availableQuantity}
                        {item?.availableQuantity <= item?.alertQuantity && (
                          <WarningIcon className="ml-1 text-amber-500" sx={{ fontSize: 12 }} />
                        )}
                      </span>
                    </td>
                    <td className="px-3 py-2">
                      <button
                        onClick={() => updatePrice(item._id)}
                        className="flex items-center gap-1 px-3 py-1.5 bg-gradient-to-r from-primary to-primaryLight text-white rounded-lg hover:shadow-lg hover:shadow-primary/20 transition-all text-xs font-medium"
                      >
                        <EditIcon sx={{ fontSize: 14 }} />
                        Update Price
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {open && <AddProduct id={id} priceOnly={priceOnly} closeModal={closeModal} />}
    </>
  );
}

export default memo(AllProduct);
